import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { PieChartComponent } from './chart-types/pie-chart/pie-chart.component';


@NgModule({
  declarations: [
    PieChartComponent
  ],
  imports: [
    CommonModule,
    BaseChartDirective
  ],
  exports: [
    PieChartComponent
  ],
  providers: [
    provideCharts(withDefaultRegisterables())
  ]
})
export class DataChartModule { }
